





















import { Component, Vue, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
    components: {
        Icon,
    },
})
export default class StatsCard extends Vue {
    @Prop(String) readonly title!: string;

    @Prop(Number) readonly count!: number;

    @Prop(String) readonly color!: string;

    @Prop(String) readonly icon!: string;

    get bgClass(): string {
        const colors: Record<string, string> = {
            yellow: 'bg-yellow-50',
            green: 'bg-green-50',
            red: 'bg-red-50',
            blue: 'bg-blue-50',
        };
        return colors[this.color] || 'bg-gray-50';
    }

    get borderClass(): string {
        const colors: Record<string, string> = {
            yellow: 'border-yellow-500',
            green: 'border-green-500',
            red: 'border-red-500',
            blue: 'border-blue-500',
        };
        return colors[this.color] || 'border-gray-500';
    }

    get textClass(): string {
        const colors: Record<string, string> = {
            yellow: 'text-yellow-600',
            green: 'text-green-600',
            red: 'text-red-600',
            blue: 'text-blue-600',
        };
        return colors[this.color] || 'text-gray-600';
    }

    get iconBgClass(): string {
        const colors: Record<string, string> = {
            yellow: 'bg-yellow-500',
            green: 'bg-green-500',
            red: 'bg-red-500',
            blue: 'bg-blue-500',
        };
        return colors[this.color] || 'bg-gray-500';
    }
}
